import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../ui/PageHeader';
import { ScaledDesign } from './ScaledDesign';
import { useAdmin } from '../AdminContext';
import { templates } from './marketingOptions';
import { clone, uniqueSlug } from '../editing';
import type { Channel, MarketingDesign, Template } from '../../core/types/marketing';
const channels: Channel[] = ['Instagram', 'Print', 'E-mail'];

/** Voorbeeldinhoud voor een sjabloon waar Sarah nog geen ontwerp van heeft. */
const placeholderFor = (t: Template): MarketingDesign => ({
  id: 'voorbeeld',
  name: t.name,
  campaign: '',
  template: t.key,
  palette: 'blush',
  eyebrow: 'Regeltje boven de kop',
  headline: 'Jouw kop hier.',
  accent: 'Met een cursief accent.',
  body: 'Een korte zin die uitlegt waarom dit ertoe doet.',
  points: ['Eerste punt', 'Tweede punt'],
  cta: 'beautybewust.nl',
  image: '',
  qrUrl: '',
  caption: '',
  hashtags: []
});

/** Kies een sjabloon; je begint met een voorbeeld dat al goed staat. */
export function MarketingNew() {
  const {
    marketing,
    setMarketing
  } = useAdmin();
  const navigate = useNavigate();
  const exampleFor = (t: Template) => marketing.designs.find(d => d.template === t.key) ?? placeholderFor(t);
  const create = (t: Template) => {
    const example = clone(exampleFor(t));
    const id = uniqueSlug(`${t.key}-nieuw`, marketing.designs.map(d => d.id));
    const design: MarketingDesign = {
      ...example,
      id,
      name: `${t.name} (nieuw)`
    };
    setMarketing(m => ({
      ...m,
      designs: [design, ...m.designs]
    }));
    navigate(`/be/ontwerpen/${id}`, {
      replace: true
    });
  };
  return <div data-id="element-2951" data-mp="20jh26izwsi57">
      <PageHeader title="Nieuw ontwerp" description="Kies een sjabloon. Je begint met een voorbeeld dat al goed staat; daarna pas je tekst, kleur en foto aan." back={{
      to: '/be/ontwerpen',
      label: 'Alle ontwerpen'
    }} data-id="element-2952" data-mp="20jpgmfbojvii" />
      <div className="space-y-10" data-id="element-2953" data-mp="3uuvsp20qulm0">
        {channels.map(c => <section key={c} data-id="element-2954" data-mp="3pvp6nyl5wdc">
            <h2 className="mb-4 font-display text-xl text-ink" data-id="element-2955" data-mp="3o1fy6wofsp3">{c}</h2>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 xl:grid-cols-4" data-id="element-2956" data-mp="2atcmsh67lga">
              {templates.filter(t => t.channel === c).map(t => <li key={t.key} data-id="element-2957" data-mp="3ogyl96836voh">
                    <button type="button" onClick={() => create(t)} className="group block w-full text-left" data-id="element-2958" data-mp="3jhdbe0rdp2wz">
                      <div className="aspect-[4/5] rounded-lg bg-white/70 p-3 ring-1 ring-line transition-colors duration-150 ease-soft group-hover:bg-white group-hover:ring-ink/30 sm:p-5" data-id="element-2959" data-mp="kzggx8riw6st">
                        <ScaledDesign design={exampleFor(t)} fill data-id="element-2960" data-mp="b9wu5s0ovsso" />
                      </div>
                      <p className="mt-3 text-[14px] text-ink" data-id="element-2961" data-mp="6atpw9sj9qlr">{t.name}</p>
                      <p className="text-[12px] text-muted" data-id="element-2962" data-mp="6ajzwm7hnjg2">{t.sizeLabel}</p>
                      <p className="mt-1 text-[12px] leading-snug text-muted" data-id="element-2963" data-mp="13qzgf5mc92q3">{t.use}</p>
                    </button>
                  </li>)}
            </ul>
          </section>)}
      </div>
    </div>;
}